require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./cloud-20190831-06.json") })
        }
      }, "path---cloud-20190831-06");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---cloud-20190831-06!./.cache/json/cloud-20190831-06.json
// module id = 760
// module chunks = 231608221292675